Ember.Application.initializer
  name: 'intercom'

  # after: 'rollbar'

  initialize: (container, application) ->
    env = container.lookup('service:environment')

    intercomEnabled = env.get('intercomEnabled')
    intercomAppId   = env.get('intercomAppId')

    return unless intercomEnabled

    require('utils/snippets/intercom-snippet')(intercomAppId)
